import { computed
       , observable }             from 'mobx'
import { RadioChangeEvent }       from 'antd/lib/radio'

import { API
       , kde_api_machine_t
       , kde_api_user_t
       , kde_api_workgroup_t }    from '../02_api'
import { CRUD
       , FACTORY
       }                          from '../09_model_app'

let g_workgroups: MWorkGroups ;

export enum WORKGROUP_TAB { USERS, MACHINES } ;

export class MWorkGroups
{
  @observable public _selected_workgroup: number | null = null ;
  @observable public workgroup_tab: WORKGROUP_TAB = WORKGROUP_TAB.USERS ;

  users = new CRUD<kde_api_user_t>(
      user => API.USERS( user? user.workgroup!.cloud.id : 0
                       , this.workgroup_id
                       , ( ret ) =>
                         {
                           FACTORY.WORKGROUP_USERS.reset( ) ;
                           return ret ;
                         } )
    , user => 
       FACTORY.WORKGROUP_USERS.data_fetcher_for( { cloud_id: user? user.workgroup!.cloud.id : 0
                                               , workgroup_id: this.workgroup_id } )
    ) ;


  workgroups = new CRUD<kde_api_workgroup_t>(
      user => API.WORKGROUPS( user? user.workgroup!.cloud.id : 0 )
    , user => 
      FACTORY.WORKGROUPS.data_fetcher_for( { cloud_id: user? user.workgroup!.cloud.id : 0 } )
    ) ;


  machines = new CRUD<kde_api_machine_t>(
      user => API.MACHINES( user? user.workgroup!.cloud.id : 0
                            , user? user.workgroup!.id : 0 )
    , user =>
      FACTORY.MACHINES.data_fetcher_for( { cloud_id: user? user.workgroup!.cloud.id : 0
                                       , workgroup_id: this.workgroup_id } )
    ) ;

  @computed get workgroup_id ( )
  {
    return this.selected_workgroup? this.selected_workgroup : 0 ;
  }

   @computed get selected_workgroup ( ) : number | null
   {
     const workgroups = this.workgroups.data_for_page( 0 ) ;

     return this._selected_workgroup === null && !workgroups.loading && workgroups.data && workgroups.data.length > 0?
            workgroups.data[ 0 ].id
          : this._selected_workgroup ;
   }


   set selected_workgroup ( value: number | null )
   {
     this._selected_workgroup = value ;
   }


   on_change_workgroup_tab = ( ev: RadioChangeEvent ) =>
    this.workgroup_tab = ev.target.value as WORKGROUP_TAB ;


   public static instance ( )
   {
     if ( !g_workgroups )
           g_workgroups = new MWorkGroups( ) ;

     return g_workgroups ;
   }
}
